module.exports = __webpack_public_path__ + "img/copytrade_sec3_3.f8872458.png";